import token, { tokenToVars } from '../token';
import Cascader from './cascader';

export { Cascader };
export default tokenToVars(Cascader, token);
